var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYuanzhuiti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92078 3.88614L3.24751 8.37129L0.871277 12.6485L1.34652 13.599L4.19801 14.5495L7.99999 15.0248L11.802 14.5495L14.6535 13.599L15.1287 12.6485L12.5445 8.22277L10.2871 5.07426L7.76237 0.5L5.92078 3.88614Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.104 12.6485C15.104 12.8479 14.998 13.0977 14.6747 13.3843C14.352 13.6704 13.8565 13.9509 13.2013 14.1967C11.8945 14.6867 10.0557 15 8.00002 15C5.94433 15 4.10552 14.6867 2.79877 14.1967C2.14355 13.9509 1.64804 13.6704 1.32532 13.3843C1.00202 13.0977 0.896057 12.8479 0.896057 12.6485C0.896057 12.4491 1.00202 12.1994 1.32532 11.9127C1.64804 11.6266 2.14355 11.3461 2.79877 11.1004C4.10552 10.6103 5.94433 10.297 8.00002 10.297C10.0557 10.297 11.8945 10.6103 13.2013 11.1004C13.8565 11.3461 14.352 11.6266 14.6747 11.9127C14.998 12.1994 15.104 12.4491 15.104 12.6485Z",
    fill: "#00C2FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.915833 12.4555L7.76237 0.767334L15.047 12.3292",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYuanzhuiti);
export default __webpack_public_path__ + "static/media/yuanzhuiti.7704ea78853960ad981989488416192e.svg";
export { ForwardRef as ReactComponent };